var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSerbia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0107422C7.1635 0.0107422 0 7.17424 0 16.0107C0 17.9679 0.352063 19.8427 0.995188 21.5759H31.0049C31.648 19.8427 32 17.9679 32 16.0107C32 7.17424 24.8365 0.0107422 16 0.0107422Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 0.0107422C9.12074 0.0107422 3.25605 4.35274 0.995361 10.4456H31.005C28.7443 4.35274 22.8796 0.0107422 16.0002 0.0107422V0.0107422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13721 9.05443V17.036C4.13721 21.5763 10.0685 22.9675 10.0685 22.9675C10.0685 22.9675 15.9998 21.5763 15.9998 17.036V9.05443H4.13721Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59009 10.4457H13.5467V7.6631L12.1553 8.35873L10.0684 6.27179L7.9814 8.35873L6.59009 7.6631V10.4457Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6087 18.1472L10.0869 13.6255L5.56519 18.1472L7.04087 19.6229L10.0869 16.5769L13.133 19.6229L14.6087 18.1472Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6087 13.9236H12.4989C12.6176 13.7189 12.6866 13.4817 12.6866 13.2281C12.6866 12.4596 12.0636 11.8368 11.2952 11.8368C10.7643 11.8368 10.3032 12.1342 10.0687 12.5714C9.83412 12.1342 9.37306 11.8368 8.84212 11.8368C8.07375 11.8368 7.45081 12.4596 7.45081 13.2281C7.45081 13.4817 7.51981 13.7189 7.63844 13.9236H5.56519C5.56519 14.692 6.2345 15.3149 7.00281 15.3149H6.9565C6.9565 16.0834 7.57937 16.7062 8.34781 16.7062C8.34781 17.3866 8.83644 17.9519 9.48175 18.0729L8.3855 20.548C8.91087 20.7615 9.485 20.8802 10.087 20.8802C10.689 20.8802 11.2631 20.7615 11.7885 20.548L10.6922 18.0729C11.3376 17.952 11.8262 17.3867 11.8262 16.7062C12.5946 16.7062 13.2175 16.0834 13.2175 15.3149H13.1712C13.9394 15.3149 14.6087 14.692 14.6087 13.9236V13.9236Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerbia);
export default __webpack_public_path__ + "static/media/serbia.c63d628b.svg";
export { ForwardRef as ReactComponent };